import { Form, Spin } from "antd";
import { useEffect } from "react";

import { useUpdate } from "@/hooks/queries";
import { useAppNotification } from "@/modules/app-notification";

import ProgressEditField from "./ProgressEditField";
import "./ProgressEditForm.style.less";

const { useForm } = Form;

const ProgressEditForm = ({ type, model, ...progressBarProps }) => {
  const [form] = useForm();
  const { notify } = useAppNotification();

  const onError = () => {
    notify.error();
    form.resetFields();
  };

  const { mutate, isPending: isLoading } = useUpdate(`${type}s`, model?.id, {
    mutationOptions: { onError },
  });

  // TODO IMP-1217 fix require-await
  // eslint-disable-next-line require-await
  const onValuesChange = async ({ progress }) => {
    if (progress !== model?.progress) mutate({ progress });
  };

  useEffect(() => {
    form.resetFields();
  }, [model]);

  return (
    <Spin spinning={isLoading}>
      <Form
        form={form}
        name="progress-edit"
        className="progress-edit-form"
        initialValues={{ progress: model?.progress ?? 0 }}
        onValuesChange={onValuesChange}
      >
        <ProgressEditField {...progressBarProps} />
      </Form>
    </Spin>
  );
};

export default ProgressEditForm;
